import React, { useEffect } from "react";
import Home from "./components/Home";
import ReactGA from "react-ga";

function App() {
	// Initialising google analytics
	useEffect(() => {
		ReactGA.initialize("UA-175638709-3");
		ReactGA.pageview(window.location.pathname);
	}, []);

	return (
		<div className="App">
			<Home />
		</div>
	);
}

export default App;
